import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Leaf } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center py-20 px-4 overflow-hidden bg-cream" data-id="element-75">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-76">
        <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-sage/10 blur-3xl" data-id="element-77" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[400px] h-[400px] rounded-full bg-terracotta/5 blur-3xl" data-id="element-78" />
      </div>

      <div className="relative max-w-3xl mx-auto text-center z-10" data-id="element-79">
        <FadeIn delay={0.1} data-id="element-80">
          <div className="flex justify-center mb-8" data-id="element-81">
            <div className="p-3 bg-sage/10 rounded-full" data-id="element-82">
              <Leaf className="w-8 h-8 text-sage" data-id="element-83" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-84">
          <p className="text-xl md:text-2xl text-brown-light mb-8 font-medium italic leading-relaxed" data-id="element-85">
            Hay un tipo de cansancio que no se arregla con dormir más.
            <br data-id="element-86" />
            Es el cansancio de vivir inflamada.
          </p>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-87">
          <h1 className="text-5xl md:text-7xl font-serif text-brown mb-6 leading-tight" data-id="element-88">
            Plan Pancita <span className="text-terracotta" data-id="element-89">Desinflamada</span>
            <span className="block text-3xl md:text-4xl mt-2 text-sage" data-id="element-90">
              (7 días)
            </span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.35} data-id="element-91">
          <div className="flex justify-center mb-10" data-id="element-92">
            <img src="https://cdn.magicpatterns.com/uploads/gWRkQVfvw2zfzgRV7gPpH8/heylloyd-image-1770968272684.png" alt="Mockup del Plan Pancita Desinflamada en laptop" className="w-full max-w-lg rounded-2xl shadow-2xl shadow-brown/10" data-id="element-93" />
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-94">
          <p className="text-lg md:text-xl text-brown-light mb-10 max-w-2xl mx-auto" data-id="element-95">
            Comida simple + menos irritantes + 2 minutos de calma + movimiento
            suave
          </p>
        </FadeIn>

        <FadeIn delay={0.5} className="flex flex-col items-center gap-4" data-id="element-96">
          <Button withArrow scrollTo="comprar" className="w-full sm:w-auto text-xl px-10 py-5" data-id="element-97">
            Quiero mi plan
          </Button>
          <p className="text-sm text-brown-light/80 font-medium tracking-wide uppercase mt-4" data-id="element-98">
            AR$ 9.300 — descarga inmediata
          </p>
        </FadeIn>
      </div>
    </section>;
}